import { Alert, Button, Input, Select, TableProps } from "antd";
import { capitalize } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast as toastMessage } from "react-toastify";
import { useAppSelector } from "../../../../app/store";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import ConfirmActionModal from "../../../../components/Businesses/ConfirmActionModal";
import SuccessModal from "../../../../components/common/SuccessModal";
import CustomTable from "../../../../components/ui/CustomTable";
import { API_URL } from "../../../../constants/apiUrl";
import { APP_API } from "../../../../constants/constants";
import {
  useGetBatchLogQuery,
  useGetSingleBatchQuery,
  useUpdateBatchMutation,
} from "../../../../features/portal/batch/batchApi";
import { useGetSingleCompanyQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useBatchRejectMutation,
  useCheckButtonForSalaryDisbursmentStatusQuery,
  useDisburesementRetryableQuery,
  useDisbursementsPaymentCheckerMutation,
  useDisbursementsPaymentWithOtpMutation,
  useGetAllDisbursementsQuery,
  useSentToCheckerMutation,
} from "../../../../features/portal/disbursementPayment/disbursementPaymentApi";
import { useGetUserPoolProjectQuery } from "../../../../features/portal/Products/productsApi";
import PinVerifyModal from "../../../../features/portal/vendorPayment/PinVerifyModal";
import { useBalanceCheckQuery } from "../../../../features/portal/vendorPayment/vendorPaymentApi";
import useDownloadEmployeeXlsx from "../../../../hooks/useDownloadExcelWithApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import ConfirmModalLayout from "../../../../layouts/ConfirmModalLayout";
import { formatDate, formatTime } from "../../../../lib/time";
import { GetSingleUserWalletRoleDataType } from "../../../../types/portal/companyOnboard";
import {
  GetAllDisbursementDataParamsType,
  GetAllDisbursementDataType,
} from "../../../../types/portal/disbursementPayment";
import { countParPageSerialNumber } from "../../../../utils/number";
import { addKeyInArray } from "../../../../utils/utils";
import AddWalletModal from "../../ShebaPayWallet/AddWalletModal";
import ViewPaymentLogModal from "./ViewPaymentLogModal";

type Props = {
  getSingleUserWalletRoleData?: GetSingleUserWalletRoleDataType;
};

export default function PendingListTable({
  getSingleUserWalletRoleData,
}: Props) {
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const [paymentStatus, setPayentStatus] = useState("true");
  const [comment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { loading: excelLoading, downloadXlsx } = useDownloadEmployeeXlsx();
  const {
    open: addWalletOpen,
    handleOpen: addWalletHandleOpen,
    handleClose: addWalletHandleClose,
  } = useModal();
  const {
    open: openConfirmSubmitModal,
    handleOpen: handleConfirmSubmitOpen,
    handleClose: handleConfirmSubmitClose,
  } = useModal<undefined, "CONFIRM_SUBMIT">();
  const {
    open: openConfirmRejectModal,
    handleOpen: handleConfirmRejectOpen,
    handleClose: handleConfirmRejectClose,
  } = useModal<undefined, "CONFIRM_REJECT">();
  const {
    open: openConfirmRejectModalApprover,
    handleOpen: handleConfirmRejectApproverOpen,
    handleClose: handleConfirmRejectApproverClose,
  } = useModal<undefined, "CONFIRM_REJECT_APPROVER">();
  const {
    open: openConfirmPaymentModal,
    handleOpen: handleConfirmPaymentOpen,
    handleClose: handleConfirmPaymentClose,
  } = useModal<undefined, "CONFIRM_PAYMENT">();
  const {
    open: openConfirmMackerModal,
    handleOpen: handleConfirmMackerOpen,
    handleClose: handleConfirmMackerClose,
  } = useModal<undefined, "CONFIRM_SUBMIT_MACKER">();

  const {
    open: openSuccessModal,
    handleOpen: handleSuccessOpen,
    handleClose: handleSuccessClose,
  } = useModal<undefined, "SUCCESS">();
  const { open, handleOpen, handleClose } = useModal<
    undefined,
    "CONFIRM_FOR_APPROVAL"
  >();

  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllDisbursementDataParamsType>({
    defaultLimit: 1000,
  });
  const { user } = useAppSelector((state) => state.auth);
  const { id, walletId } = useParams();
  const navigate = useNavigate();

  // const {
  //   data: getSingleUserWalletRoleData,
  //   isError: getSingleUserWalletRoleIsError,
  //   error: getSingleUserWalletRoleError,
  //   isLoading: getSingleUserWalletRoleIsLoading,
  // } = useGetSingleUserWalletRoleQuery(
  //   {
  //     walletId: walletId ? Number(walletId) : undefined,
  //     userId: user?.data?.id,
  //   },
  //   { skip: !walletId || !user?.data?.id }
  // );

  const roleCheck = localStorage.getItem("project_role");

  const {
    isError: singleBatchIsError,
    error: singleBatchError,
    data: singleBatchData,
    isLoading: singleBatchIsLoading,
    refetch: singleBatchRefetch,
  } = useGetSingleBatchQuery(id);

  const {
    isLoading: isCompanyDetailsLoading,
    isError: isCompanyDetailsError,
    error: companyDetailsError,
    data: companyDetails,
  } = useGetSingleCompanyQuery(user?.data?.company_id, {
    skip: !user?.data?.company_id,
  });

  // const {
  //   isLoading: isBalanceCheckLoading,
  //   isError: isBalanceCheckError,
  //   error: balanceCheckError,
  //   data: balanceCheck,
  // } = useBalanceCheckQuery(
  //   {
  //     walletNumber: companyDetails?.data?.wallet_number || "",
  //     companyId: user?.data?.company_id,
  //   },
  //   {
  //     skip: !companyDetails?.data?.wallet_number || !user?.data?.company_id,
  //   }
  // );

  const {
    isLoading: isBalanceCheckLoading,
    isError: isBalanceCheckError,
    error: balanceCheckError,
    data: balanceCheck,
  } = useBalanceCheckQuery(
    {
      walletNumber: companyDetails?.data?.wallet_number || "",
      companyId: user?.data?.company_id,
    },
    {
      skip: !companyDetails?.data?.wallet_number || !user?.data?.company_id,
    }
  );

  const walletRole = getSingleUserWalletRoleData?.data?.role;
  let permission = "";

  if (walletRole === "maker" && roleCheck === "User") {
    permission = "maker";
  } else if (walletRole === "checker" && roleCheck === "User") {
    permission = "checker";
  } else if (walletRole === "approver" && roleCheck === "User") {
    permission = "approver";
  } else if (roleCheck === "Admin") {
    permission = "admin";
  }

  const {
    isLoading: isVendorLoading,
    isError: isVendorDetailsError,
    error: vendorDetailsError,
    data: vendorDetails,
    refetch,
  } = useGetAllDisbursementsQuery(
    {
      params: {
        ...filter,
        batch_id: id,
        company_id: user?.data?.company_id,
        permission,
        page,
        limit,
        search: keyword,
      },
    },
    {
      skip: !id || !user?.data?.company_id,
    }
  );
  const [
    sentToChecker,
    {
      isLoading: sentToCheckerIsLoading,
      isError: sentToCheckerIsError,
      error: sentToCheckerError,
      isSuccess: sentToCheckerIsSuccess,
    },
  ] = useSentToCheckerMutation();

  const shouldFetchUserPoolProject =
    roleCheck === "User" &&
    walletRole === "approver" &&
    !!singleBatchData?.data?.projectId;
  const {
    isError: isUserPoolProjectError,
    error: userPoolProjectError,
    data: userPoolProjectData,
  } = useGetUserPoolProjectQuery(
    {
      params: {
        userId: user?.data?.id,
        projectId: singleBatchData?.data?.projectId,
      },
    },
    {
      skip: !shouldFetchUserPoolProject,
    }
  );
  const [
    updateBatch,
    {
      isError: isUpdateBatchError,
      error: updateBatchError,
      isSuccess: isUpdateBatchSuccess,
      isLoading: isUpdateBatchLoading,
    },
  ] = useUpdateBatchMutation();

  // const {
  //   isError: isUserPerformBatchError,
  //   error: userPerformBatchError,
  //   data: userPerformBatchData,
  // } = useGetUserPerformBatchQuery(
  //   {
  //     params: {
  //       userId: user?.data?.id,
  //       batchId: id,
  //     },
  //   },
  //   {
  //     skip: !user?.data?.id,
  //   }
  // );

  console.log("singleBatchData:", singleBatchData?.data?.numberOfPollA);

  const [
    batchReject,
    {
      isSuccess: batchRejectIsSuccess,
      isLoading: batchRejectIsLoading,
      isError: batchRejectIsError,
      error: batchRejectError,
    },
  ] = useBatchRejectMutation();

  useError(isVendorDetailsError, vendorDetailsError, "Get payment data fail");
  useError(
    isUserPoolProjectError,
    userPoolProjectError,
    "Get user pool project fail"
  );
  const [
    disbursementsPaymentChecker,
    {
      isError: isPaymentCheckerError,
      error: paymentCheckerError,
      isSuccess: isPaymentCheckerSuccess,
      isLoading: paymentCheckerIsLoading,
    },
  ] = useDisbursementsPaymentCheckerMutation();
  const [
    salaryPaymentWithOtp,
    {
      isError: isSalaryPaymentError,
      error: salaryPaymentError,
      isLoading: isSalaryPaymentLoading,
      isSuccess: isSalaryPaymentSuccess,
      data: salaryPaymentData,
    },
  ] = useDisbursementsPaymentWithOtpMutation();

  let current_stage_wallet = "";

  if (walletRole === "maker" && roleCheck === "User") {
    current_stage_wallet = "Maker";
  } else if (walletRole === "checker" && roleCheck === "User") {
    current_stage_wallet = "Checker";
  } else if (walletRole === "approver" && roleCheck === "User") {
    current_stage_wallet = "Approver";
  } else if (roleCheck === "Admin") {
    current_stage_wallet = "Admin";
  }

  const { data: CheckButtonForSalaryDisbursmentStatusData } =
    useCheckButtonForSalaryDisbursmentStatusQuery(
      {
        params: {
          batch_id: id ? Number(id) : undefined,
          current_stage: current_stage_wallet,
          status: "pending",
        },
      },
      {
        skip: !id || !current_stage_wallet,
      }
    );

  const {
    isError: isBatchLogError,
    error: batchLogError,
    isLoading: isBatchLogLoading,
    data: batchLogData,
    refetch: batchLogRefetch,
  } = useGetBatchLogQuery(
    {
      params: {
        id: id,
      },
    },
    {
      skip: !id,
    }
  );

  const {
    data: disburesementRetryableData,
    isError: disburesementRetryableIsError,
    error: disburesementRetryableError,
    isLoading: disburesementRetryableIsLoading,
  } = useDisburesementRetryableQuery(
    {
      params: {
        batch_id: id,
      },
    },
    {
      skip: roleCheck !== "User" && walletRole !== "approver",
    }
  );

  // const { data: CheckButtonForSalaryDisbursmentStatusRejectData } =
  //   useCheckButtonForSalaryDisbursmentStatusQuery({
  //     params: {
  //       batch_id: id ? Number(id) : undefined,
  //       current_stage: roleCheck ?? undefined,
  //       status: "reject",
  //     },
  //   });

  // console.log("Reject", CheckButtonForSalaryDisbursmentStatusRejectData);
  // console.log("Submit", CheckButtonForSalaryDisbursmentStatusRejectData);
  useError(isSalaryPaymentError, salaryPaymentError, "Salary payment otp fail");
  useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");
  useError(isBalanceCheckError, balanceCheckError, "Get balance data fail");
  useError(sentToCheckerIsError, sentToCheckerError, "Sent to checkeer fail");
  useError(singleBatchIsError, singleBatchError, "Get single batch fail");
  useError(isUpdateBatchError, updateBatchError, "Batch update fail");
  useError(isPaymentCheckerError, paymentCheckerError, "Send to approver fail");
  useError(batchRejectIsError, batchRejectError, "Batch reject fail");
  useError(
    disburesementRetryableIsError,
    disburesementRetryableError,
    "Disburesement retryable get fail"
  );
  // useError(
  //   getSingleUserWalletRoleIsError,
  //   getSingleUserWalletRoleError,
  //   "Get single user wallet role failed"
  // );
  useError(isBatchLogError, batchLogError, "Get batch log data failed");

  const columns: TableProps<GetAllDisbursementDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Employee ID</div>,
      dataIndex: "employee_id",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Employee Name</span>,
      dataIndex: "employee_name",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Department</span>,
      align: "center",
      dataIndex: "department",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Designation</span>,
      dataIndex: "designation",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Amount (BDT)</span>,
      dataIndex: "amount",
      align: "center",
      render: (val: string | number) => (
        <>
          ৳{" "}
          {val
            ? Number(val)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0"}
        </>
      ),
    },
    {
      title: <span className="whitespace-nowrap">Payment Type</span>,
      align: "center",
      dataIndex: "disbursement_type",
      render: (val: string) =>
        val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : "N/A",
    },
    {
      title: <span className="whitespace-nowrap">Wallet Number</span>,
      dataIndex: "wallet_number",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Bank Name</span>,
      dataIndex: "bank_name",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Account Title</span>,
      dataIndex: "account_title",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Account Number</span>,
      dataIndex: "account_number",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Branch Name</span>,
      dataIndex: "branch_name",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Routing Number</span>,
      dataIndex: "routing_number",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Transaction ID</span>,
      dataIndex: "transaction_id",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Transaction Date</span>,
      dataIndex: "transaction_date",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <span className="whitespace-nowrap">Created At</span>,
      align: "center",
      dataIndex: "created_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <span className="whitespace-nowrap">Updated At</span>,
      align: "center",
      dataIndex: "updated_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <span className="whitespace-nowrap">Narration</span>,
      dataIndex: "narration",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Remarks</span>,
      dataIndex: "remarks",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <div className="whitespace-nowrap !w-[110px]">Current Stage</div>,
      dataIndex: "current_stage",
      align: "center",
      render: (val) => (
        <span
          className={`px-2 py-1 rounded text-xs font-medium bg-yellow-100 text-yellow-700`}
        >
          {val.charAt(0).toUpperCase() + val.slice(1)}
        </span>
      ),
    },
    // {
    //   title: <div className="whitespace-nowrap !w-[110px]">Status</div>,
    //   dataIndex: "status",
    //   align: "center",
    //   render: (val) => (
    //     <span
    //       className={`px-2 py-1 rounded text-xs font-medium ${
    //         val === "pending"
    //           ? "bg-yellow-100 text-yellow-700"
    //           : "bg-green-100 text-green-700"
    //       }`}
    //     >
    //       {capitalize(val)}
    //     </span>
    //   ),
    // },
    {
      title: <div className="whitespace-nowrap !w-[110px]">Status</div>,
      dataIndex: "status",
      align: "center",
      render: (val: "pending" | "success" | "failed" | "reject" | string) => {
        const statusClasses: Record<string, string> = {
          pending: "bg-yellow-100 text-yellow-700",
          success: "bg-green-100 text-green-700",
          failed: "bg-red-100 text-red-700",
          reject: "bg-red-100 text-red-700",
        };

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              statusClasses[val] || "bg-yellow-100 text-yellow-700"
            }`}
          >
            {capitalize(val)}
          </span>
        );
      },
    },
    // {
    //   title: <div className="whitespace-nowrap !w-[110px]">Action Log</div>,
    //   align: "center",
    //   render: (record: any) => (
    //     <Button onClick={() => handleOpen({ type: "VIEW" })}>View</Button>
    //   ),
    // },
  ];

  const singleBatch = singleBatchData?.data;

  const handleMackerSubmit = () => {
    const newData = {
      disbursementIds: selectedData,
    };
    // console.log("newData", newData);
    sentToChecker({
      data: newData,
    });
  };

  const handleSentToChecker = (value: string) => {
    const newData = {
      remarks: value,
    };
    disbursementsPaymentChecker({
      id: id,
      data: newData,
    });
  };

  const handlePoolChecked = () => {
    if (walletRole !== "approver") {
      return null;
    }
    // console.log({ roleCheck, walletRole });
    // if (singleBatchData?.data?.status !== "approver") {
    //   return null;
    // }

    const poolName = userPoolProjectData?.data?.poolName;

    if (
      singleBatchData?.data?.numberOfPollA ===
        Number(singleBatchData?.data?.numberOfPoolACheck) &&
      singleBatchData?.data?.numberOfPollB ===
        Number(singleBatchData?.data?.numberOfPoolBCheck)
    ) {
      // payment korte parbe
      return "PAYMENT";
    } else if (poolName === "Pool A" && singleBatchData?.data?.numberOfPollA) {
      if (
        singleBatchData?.data?.numberOfPollA >
        Number(singleBatchData?.data?.numberOfPoolACheck)
      ) {
        // send to approve korte parbe
        return "APPROVE";
      }

      return null;
    } else if (poolName === "Pool B" && singleBatchData?.data?.numberOfPollB) {
      if (
        singleBatchData?.data?.numberOfPollB >
        Number(singleBatchData?.data?.numberOfPoolBCheck)
      ) {
        // send to approve korte parbe
        return "APPROVE";
      }

      return null;
    }

    return null;
  };

  const handleSendToApprove = async () => {
    const poolName = userPoolProjectData?.data?.poolName;
    let obj = {};
    if (poolName === "Pool A") {
      obj = {
        numberOfPoolACheck:
          (singleBatchData?.data?.numberOfPoolACheck || 0) + 1,
      };
    }
    if (poolName === "Pool B") {
      obj = {
        numberOfPoolBCheck:
          (singleBatchData?.data?.numberOfPoolBCheck || 0) + 1,
      };
    }

    if (handlePoolChecked() === "APPROVE") {
      updateBatch({
        id: id,
        data: {
          status: "approver",
          remarks: comment,
          pool: poolName,
          ...obj,
        },
      });

      return;
    }

    if (!selectedData?.length) return;

    setIsLoading(true);

    try {
      await Promise.all(
        selectedData.map((el: any) =>
          disbursementsPaymentChecker({ id: el }).unwrap()
        )
      );
    } catch (error: any) {
      toastMessage.error(
        error?.data?.data?.message || "Failed to send payment data"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleBatchRejectChecker = (value: string) => {
    const poolName = userPoolProjectData?.data?.poolName;
    const newData = {
      batchId: id,
      current_stage: current_stage_wallet?.toLocaleLowerCase(),
      pool: poolName,
      remarks: value,
      status: "checker",
    };
    batchReject({
      data: newData,
    });
  };

  const handleBatchRejectApprover = (value: string) => {
    const poolName = userPoolProjectData?.data?.poolName;
    const newData = {
      batchId: id,
      current_stage: current_stage_wallet?.toLocaleLowerCase(),
      pool: poolName,
      remarks: value,
      status: "approver",
    };

    batchReject({
      data: newData,
    });
  };

  const getModalTitle = () => {
    if (openConfirmMackerModal.type === "CONFIRM_SUBMIT_MACKER")
      return "Payment Request Submitted Successfully!";
    if (openConfirmSubmitModal.type === "CONFIRM_SUBMIT")
      return "Successfully sent to the approver!";
    if (openConfirmPaymentModal.type === "CONFIRM_PAYMENT")
      return "Payment disbursed successfully!";
    if (openConfirmRejectModal.type === "CONFIRM_REJECT")
      return "Payment Request Rejected Successfully!";
    if (openConfirmRejectModalApprover.type === "CONFIRM_REJECT_APPROVER")
      return "Payment Request Rejected Successfully!";
    return "";
  };

  const handleOkay = () => {
    handleConfirmMackerClose();
    handleSuccessClose();
    handleConfirmSubmitClose();
    handleConfirmRejectClose();
    handleConfirmRejectApproverClose();
  };

  const selectedRows =
    vendorDetails?.data?.data?.filter((row: any) =>
      selectedData.includes(row.id)
    ) || [];
  const totalSelectedAmount = selectedRows.reduce(
    (sum: number, row: any) => sum + (Number(row.amount) || 0),
    0
  );

  const totalAmount = vendorDetails?.data?.data?.reduce(
    (sum, item) => sum + Number(item?.amount || 0),
    0
  );

  const walletBalance = balanceCheck?.data?.data?.Amount;

  const isWalletSufficient = Number(walletBalance) >= (totalAmount ?? 0);

  // Maker reject status
  const makerRejectStatus = vendorDetails?.data?.data?.[0]?.status;

  const pendingPoolA =
    (singleBatchData?.data?.numberOfPollA || 0) -
    (singleBatchData?.data?.numberOfPoolACheck || 0);

  const pendingPoolB =
    (singleBatchData?.data?.numberOfPollB || 0) -
    (singleBatchData?.data?.numberOfPoolBCheck || 0);

  const handleDownload = () => {
    downloadXlsx(
      APP_API + API_URL.getAllDisbursements,
      {
        ...filter,
        page: page,
        search: keyword,
        skip: 0,
        limit: 1000000000000000,
        batch_id: id,
        company_id: user?.data?.company_id,
        permission,
      },
      `Salary_Disbursment_${
        singleBatch?.batchName
      }_Pending List_${moment().format("DD MMMM YYYY")}_${moment().format(
        "h.mm.ss A"
      )}`,
      "data",
      (item: GetAllDisbursementDataType["data"]["data"][0]) => {
        return {
          "Employee ID": item?.employee_id || "-",
          "Employee Name": item?.employee_name || "-",
          Department: item?.department || "-",
          Designation: item?.designation || "-",
          Amount:
            item?.amount !== undefined && item?.amount !== null
              ? Number(item.amount).toLocaleString("en-IN")
              : "-",
          "Payment Type": capitalize(item?.disbursement_type) || "-",
          "Wallet Number": item?.wallet_number || "-",
          "Bank Name": item?.bank_name || "-",
          "Account Title": item?.account_title || "-",
          "Account Number": item?.account_number || "-",
          "Branch Name": item?.branch_name || "-",
          "Routing Number": item?.routing_number || "-",
          "	Transaction ID": item?.transaction_id || "-",
          "Transaction Date": item?.transaction_date || "-",
          "Created At": item?.created_at
            ? `${formatDate(item?.created_at)}, ${formatTime(item?.created_at)}`
            : "-",
          "Updated At": item?.updated_at
            ? `${formatDate(item?.updated_at)}, ${formatTime(item?.updated_at)}`
            : "-",
          Narration: item.narration || "-",
          Remarks: item?.remarks || "-",
          "Current Stage": capitalize(item?.current_stage) || "-",
          Status: capitalize(item?.status) || "-",
        };
      }
    );
  };

  const reFetchAll = () => {
    singleBatchRefetch();
    refetch();
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     refetch();
  //   }, 2000); // 2000ms = 2 seconds

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(interval);
  // }, [refetch]);

  useEffect(() => {
    if (sentToCheckerIsSuccess) {
      handleSuccessOpen({ type: "SUCCESS" });
      setSelectedData([]);
      batchLogRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sentToCheckerIsSuccess]);

  useEffect(() => {
    if (
      isPaymentCheckerSuccess &&
      walletRole === "checker" &&
      roleCheck === "User"
    ) {
      handleSuccessOpen({ type: "SUCCESS" });
      setSelectedData([]);
      batchLogRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentCheckerSuccess, walletRole === "checker", roleCheck === "User"]);

  useEffect(() => {
    if (isPaymentCheckerSuccess && handlePoolChecked() === "APPROVE") {
      const poolName = userPoolProjectData?.data?.poolName;
      console.log("isPaymentCheckerSuccess comment", comment);
      updateBatch({
        id: id,
        data: {
          status: "approver",
          pool: poolName,
          remarks: comment,
        },
      });

      toastMessage.success("Payment data sent successfully");
      setSelectedData([]);
      setComment("");
      handleClose();
      batchLogRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentCheckerSuccess, handlePoolChecked() === "APPROVE"]);

  useEffect(() => {
    if (isUpdateBatchSuccess) {
      handleClose();
      setComment("");
      setSelectedData([]);
      toastMessage.success("Payment data sent successfully");
      batchLogRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateBatchSuccess]);

  useEffect(() => {
    if (batchRejectIsSuccess) {
      handleSuccessOpen({ type: "SUCCESS" });
      setComment("");
      batchLogRefetch();

      // toastMessage.success("Payment data sent successfully");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchRejectIsSuccess]);

  useEffect(() => {
    if (isVendorDetailsError || singleBatchIsError) {
      setTimeout(() => {
        navigate("/admin/salary-disbursement/batch");
      }, 1500);
    }
  }, [isVendorDetailsError, singleBatchIsError, navigate]);

  return (
    <>
      {open?.type === "VIEW" && (
        <ViewPaymentLogModal
          title=""
          subTitle=""
          buttonName="Send"
          open={open?.open}
          handleClose={handleClose}
          action
          buttonBgDeep
          loading={isLoading}
          batchLogData={batchLogData}
        />
      )}

      {open?.type === "CONFIRM" && (
        <ConfirmModalLayout
          title="Send to Approver"
          subTitle="Are you sure you want to send payment data to approver?"
          buttonName="Send"
          handleButton={handleSendToApprove}
          open={open?.open}
          handleClose={handleClose}
          action
          buttonBgDeep
          loading={isUpdateBatchLoading}
        >
          <div>
            <div className="mb-2 text-[#5E718D]">Comment</div>
            <Input
              placeholder="Enter comment"
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        </ConfirmModalLayout>
      )}

      {addWalletOpen?.type === "ADD" || addWalletOpen?.type === "UPDATE" ? (
        <AddWalletModal
          open={addWalletOpen?.open}
          handleClose={addWalletHandleClose}
          data={companyDetails?.data?.wallet_number}
          type={addWalletOpen?.type}
        />
      ) : null}

      {openConfirmSubmitModal.type === "CONFIRM_SUBMIT" && (
        <ConfirmActionModal
          title="Are you sure you want to submit payment request?"
          handleClose={handleConfirmSubmitClose}
          open={openConfirmSubmitModal.open}
          isLoading={paymentCheckerIsLoading}
          isSubmit
          handleCheckerSubmit={(val) => handleSentToChecker(String(val))}
        />
      )}

      {openConfirmMackerModal.type === "CONFIRM_SUBMIT_MACKER" && (
        <ConfirmActionModal
          title="Are you sure you want to submit payment request?"
          handleClose={handleConfirmMackerClose}
          handleMackerSubmit={handleMackerSubmit}
          open={openConfirmMackerModal.open}
          isLoading={sentToCheckerIsLoading}
          isYesSubmit
        />
      )}

      {openConfirmPaymentModal.type === "CONFIRM_PAYMENT" && (
        <ConfirmActionModal
          title="Are you sure you want to submit payment request?"
          handleClose={handleConfirmPaymentClose}
          open={openConfirmPaymentModal.open}
          isPayment
        />
      )}

      {openConfirmRejectModal.type === "CONFIRM_REJECT" && (
        <ConfirmActionModal
          title="Are you sure you want to reject payment request?"
          handleClose={handleConfirmRejectClose}
          open={openConfirmRejectModal.open}
          handleBatchRejectSubmit={(val) =>
            handleBatchRejectChecker(String(val))
          }
          isLoading={batchRejectIsLoading}
          isReject
        />
      )}

      {openConfirmRejectModalApprover.type === "CONFIRM_REJECT_APPROVER" && (
        <ConfirmActionModal
          title="Are you sure you want to reject payment request?"
          handleClose={handleConfirmRejectApproverClose}
          open={openConfirmRejectModalApprover.open}
          handleBatchRejectSubmit={(val) =>
            handleBatchRejectApprover(String(val))
          }
          isLoading={batchRejectIsLoading}
          isReject
        />
      )}

      {openSuccessModal.type === "SUCCESS" && (
        <SuccessModal
          open={openSuccessModal?.open}
          handleClose={handleSuccessClose}
          handleOkay={handleOkay}
          data={openSuccessModal?.data}
          title={getModalTitle()}
        />
      )}

      {open?.type === "CONFIRM_FOR_APPROVAL" && (
        <PinVerifyModal
          open={open?.open}
          handleClose={handleClose}
          refetch={reFetchAll}
          isPaymentLoading={isSalaryPaymentLoading || isUpdateBatchLoading}
          isPaymentSuccess={isSalaryPaymentSuccess}
          paymentApi={(data) => {
            salaryPaymentWithOtp(data);
          }}
          paymentMessage={
            salaryPaymentData?.message || "Payment approved successfully"
          }
          batchId={id}
        />
        // <ConfirmModalLayout
        //   title="Approve"
        //   subTitle="Are you sure you want to approve payment"
        //   buttonName="Approved"
        //   handleButton={handleApprover}
        //   open={open?.open}
        //   handleClose={() => {
        //     handleClose();
        //     refetch();
        //     setSelectedData([]);
        //   }}
        //   action
        //   buttonBgDeep
        //   loading={isLoading}
        // >
        //   <Form.Item
        //     // label="Pin Number"
        //     name="pn"
        //     rules={[
        //       {
        //         required: true,
        //         message: "Please enter pin number",
        //       },
        //       {
        //         pattern: /^\d{6,}$/,
        //         message: "Pin number must be at least 6 digits",
        //       },
        //     ]}
        //   >
        //     <Input
        //       placeholder="Enter pin number"
        //       onChange={(e) => setPinNumber(e.target.value)}
        //     />
        //   </Form.Item>
        // </ConfirmModalLayout>
      )}

      <div>
        {/* <div>
          {paymentStatus === "true" && (
            <>
              <Card style={{ width: "100%", marginBottom: "25px" }}>
                {isCompanyDetailsLoading ? (
                  <Loader />
                ) : user?.data?.company_id &&
                  (roleCheck === "Admin" ||
                    roleCheck === "Approver" ||
                    role === "SUPER_ADMIN") ? (
                  <>
                    <div className="flex justify-between items-center">
                      <div className="flex justify-start items-center gap-2">
                        <img
                          src={companyDetails?.data?.logo || AvatarImage}
                          alt=""
                          className="w-14 h-14 rounded-full"
                        />
                        <div className="ml-2">
                          <div className="text-blue-500 text-lg font-semibold leading-normal mb-0.5">
                            {companyDetails?.data?.company_name}
                          </div>
                          {companyDetails?.data?.wallet_number ? (
                            <p className="text-blue-500 text-sm font-medium leading-tight flex items-center gap-3">
                              <span>
                                Wallet No:{" "}
                                {companyDetails?.data?.wallet_number || "N/A"}{" "}
                              </span>
                              {roleCheck === "Admin" ||
                              roleCheck === "Approver" ||
                              role === "SUPER_ADMIN" ? (
                                <span
                                  className="cursor-pointer"
                                  onClick={() =>
                                    addWalletHandleOpen({ type: "UPDATE" })
                                  }
                                >
                                  <EditIcon />
                                </span>
                              ) : null}
                            </p>
                          ) : roleCheck === "Admin" ||
                            roleCheck === "Approver" ||
                            role === "SUPER_ADMIN" ? (
                            <Button
                              icon={<AddIcon />}
                              onClick={() =>
                                addWalletHandleOpen({ type: "ADD" })
                              }
                              className="mt-2"
                              type="primary"
                              size="small"
                            >
                              Add Wallet
                            </Button>
                          ) : null}
                        </div>
                      </div>

                      {isBalanceCheckLoading ? (
                        <Spin />
                      ) : user?.data?.company_id ? (
                        <BalanceSlide>
                          {addCommaInNumber(
                            Math.round(balanceCheck?.data?.data?.Amount || 0)
                          )}
                          BDT
                        </BalanceSlide>
                      ) : null}
                    </div>

                  
                  </>
                ) : null}

                {roleCheck === "Maker" || roleCheck === "Checker" ? (
                  <div className="mb-3  flex justify-end">
                    {isBalanceCheckLoading ? (
                      <Spin />
                    ) : user?.data?.company_id ? (
                      <BalanceSlide>
                        {addCommaInNumber(
                          Math.round(balanceCheck?.data?.data?.Amount || 0)
                        )}
                        BDT
                      </BalanceSlide>
                    ) : null}
                  </div>
                ) : null}
              </Card>
            </>
          )}
        </div> */}

        <div className="flex justify-between items-center mb-3">
          <div className="justify-start text-zinc-700 text-xl font-semibold font-['Inter'] leading-loose">
            Disbursement List
          </div>
          <div className="gap-3 flex justify-end items-center">
            <Button onClick={() => handleOpen({ type: "VIEW" })}>
              Activity Log
            </Button>
            <Button
              disabled={!vendorDetails?.data?.data?.length}
              onClick={handleDownload}
              loading={excelLoading}
              className="h-9 px-3.5 py-2 !bg-white rounded-md outline outline-1 outline-offset-[-1px] !outline-blue-500 inline-flex justify-center items-center gap-2.5 overflow-hidden disabled:cursor-not-allowed"
            >
              <span className="text-blue-600 text-sm font-semibold">
                Download
              </span>
            </Button>
          </div>
        </div>

        <CustomTable
          loading={isVendorLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={vendorDetails?.data?.count}
          dataSource={addKeyInArray(vendorDetails?.data?.data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          {...(walletRole === "maker" && roleCheck === "User"
            ? {
                rowSelection: {
                  type: "checkbox",
                  selectedRowKeys: selectedData,
                  onChange: (key) => {
                    setSelectedData(key as string[]);
                  },
                  getCheckboxProps: (record) => {
                    return {
                      disabled:
                        record?.status === "invited" ||
                        (record?.current_stage === "checker" &&
                          walletRole === "maker" &&
                          roleCheck === "User"),
                    };
                  },
                  columnWidth: 40,
                },
              }
            : {})}
          filterSection={
            <>
              {walletRole === "maker" && roleCheck === "User" && (
                <div className="px-3 py-1 bg-violet-50 rounded-[100px] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-blue-600 text-base font-medium">
                    Total Amount: ৳{" "}
                    {Number(totalSelectedAmount)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0"}
                  </div>
                </div>
              )}

              {walletRole === "checker" && roleCheck === "User" && (
                <div className="px-3 py-1 bg-violet-50 rounded-[100px] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-blue-600 text-base font-medium">
                    Total Amount: ৳{" "}
                    {Number(totalAmount)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0"}
                  </div>
                </div>
              )}

              {walletRole === "approver" && roleCheck === "User" && (
                <>
                  <div className="px-3 py-1 bg-violet-50 rounded-[100px] inline-flex justify-center items-center gap-2.5">
                    <div className="justify-start text-blue-600 text-base font-medium">
                      Total Amount: ৳{" "}
                      {Number(totalAmount)
                        .toFixed(2)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0"}
                    </div>
                  </div>

                  {isBalanceCheckLoading ? null : (
                    <>
                      {!isWalletSufficient && (
                        <div className=" w-full">
                          <Alert
                            message="Your wallet balance is not sufficent please recharge."
                            type="warning"
                            showIcon
                            closable
                            style={{
                              height: "35px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}

                  <div className="w-full">
                    <Alert
                      message={`Pending: Pool A (${pendingPoolA}), Pool B (${pendingPoolB})`}
                      type="info"
                      // showIcon
                      closable
                      style={{
                        height: "35px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    />
                  </div>
                </>
              )}

              <Input
                suffix={<SearchIcon />}
                placeholder="Search ID, Name, Wallet, Ac. Number"
                style={{ width: 317 }}
                allowClear
                onChange={handleSearch}
              />

              <Select
                placeholder="Payment Type"
                showSearch
                options={[
                  { label: "Bank", value: "bank" },
                  { label: "Wallet", value: "wallet" },
                ]}
                value={filter?.payment_type ?? undefined}
                onChange={(value) => handleFilter("payment_type", value)}
                className="!min-w-[110px]"
                suffixIcon={<SelectDownIcon />}
                // style={{ width: "100%" }}
                allowClear
                optionFilterProp="label"
              />

              <Select
                placeholder="Status"
                showSearch
                options={[
                  { label: "Pending", value: "pending" },
                  {
                    label: "Success",
                    value: "success",
                  },
                  { label: "Failed", value: "failed" },
                  { label: "Reject", value: "reject" },
                ]}
                value={filter?.status ?? undefined}
                onChange={(value) => handleFilter("status", value)}
                className="!min-w-[110px]"
                suffixIcon={<SelectDownIcon />}
                // style={{ width: "100%" }}
                allowClear
                optionFilterProp="label"
              />

              {walletRole === "maker" && roleCheck === "User" && (
                <Button
                  onClick={() =>
                    handleConfirmMackerOpen({ type: "CONFIRM_SUBMIT_MACKER" })
                  }
                  disabled={
                    selectedData.length === 0 || makerRejectStatus === "reject"
                  }
                  className="cursor-pointer h-9 px-3.5 py-2 !bg-orange-500 rounded-md inline-flex justify-center items-center gap-2.5"
                >
                  <span className="!text-white text-sm font-semibold">
                    Send to next
                  </span>
                </Button>
              )}

              {walletRole === "checker" && roleCheck === "User" && (
                <>
                  <Button
                    onClick={() =>
                      handleConfirmRejectOpen({ type: "CONFIRM_REJECT" })
                    }
                    disabled={
                      CheckButtonForSalaryDisbursmentStatusData?.data
                        ?.status === false
                    }
                    className="cursor-pointer h-9 px-3.5 py-2 !bg-red-50 rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-center items-center gap-2.5"
                  >
                    <span className="text-red-500 text-sm font-semibold">
                      Reject
                    </span>
                  </Button>

                  <Button
                    onClick={() =>
                      handleConfirmSubmitOpen({ type: "CONFIRM_SUBMIT" })
                    }
                    disabled={
                      CheckButtonForSalaryDisbursmentStatusData?.data
                        ?.status === false
                    }
                    className="cursor-pointer h-9 px-3.5 py-2 !bg-orange-500 rounded-md inline-flex justify-center items-center gap-2.5"
                  >
                    <span className="!text-white text-sm font-semibold">
                      Send to next
                    </span>
                  </Button>
                </>
              )}

              {handlePoolChecked() === "APPROVE" && (
                <>
                  <Button
                    onClick={() =>
                      handleConfirmRejectApproverOpen({
                        type: "CONFIRM_REJECT_APPROVER",
                      })
                    }
                    disabled={
                      CheckButtonForSalaryDisbursmentStatusData?.data
                        ?.status === false
                    }
                    className="cursor-pointer h-9 px-3.5 py-2 !bg-red-50 rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-center items-center gap-2.5"
                  >
                    <span className="text-red-500 text-sm font-semibold">
                      Reject
                    </span>
                  </Button>

                  <Button
                    className="middle-button min-w-[120px]"
                    type="primary"
                    disabled={
                      vendorDetails?.data?.data?.length === 0 ||
                      isWalletSufficient === false ||
                      CheckButtonForSalaryDisbursmentStatusData?.data
                        ?.status === false
                    }
                    onClick={() => handleOpen({ type: "CONFIRM" })}
                    loading={isUpdateBatchLoading}
                  >
                    Approve
                  </Button>
                </>
              )}

              {/* {handlePoolChecked() === "PAYMENT" && (
                <Button
                  className="middle-button min-w-[120px]"
                  type="primary"
                  // disabled={
                  //   CheckButtonForSalaryDisbursmentStatusData?.data?.status ===
                  //     false || !companyDetails?.data?.wallet_number
                  // }
                  disabled={
                    disburesementRetryableData?.data?.status === false ||
                    !companyDetails?.data?.wallet_number ||
                    singleBatchData?.data?.is_batch_processing === true
                  }
                  onClick={() => handleOpen({ type: "CONFIRM_FOR_APPROVAL" })}
                  loading={
                    isSalaryPaymentLoading || disburesementRetryableIsLoading
                  }
                >
                  Payment
                </Button>
              )} */}

              {handlePoolChecked() === "PAYMENT" && (
                <Button
                  className="middle-button min-w-[120px]"
                  type="primary"
                  disabled={
                    !disburesementRetryableData?.data?.status || // Disbursement not ready (false) status is false/undefined
                    !companyDetails?.data?.wallet_number || // Company wallet not set ("") wallet_number is missing
                    (disburesementRetryableData?.data?.status &&
                      singleBatchData?.data?.is_batch_processing) // Batch still processing (true && true) status is true but is_batch_processing is true
                  }
                  onClick={() => handleOpen({ type: "CONFIRM_FOR_APPROVAL" })}
                  loading={
                    isSalaryPaymentLoading || disburesementRetryableIsLoading
                  }
                >
                  Payment
                </Button>
              )}
            </>
          }
        />
      </div>
    </>
  );
}
